module.exports = __webpack_public_path__ + "static/media/giftOrangeIcon.c7181fa7.png";